module.exports = __webpack_public_path__ + "media/images/games/k2gender/eggpd-1c044c14d2f05c5158d9f599a5e4c0b1.png";